import styles from "./loader.module.css";

const Loader = ({ size, color }) => {
  return (
    <div
      className={styles.loader}
      style={{
        width: `${size}px`,
        height: `${size}px`,
        borderWidth: `${size / 10}px`,
        borderTopColor: color,
      }}
    ></div>
  );
};

export default Loader;
